import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['filter', 'item']

  filter(event) {
    const selectedCategory = event.currentTarget.dataset.category

    this.filterTargets.forEach((button) => {
      const isSelected = button === event.currentTarget

      button.classList.toggle('border-[#0D4F84]', isSelected)
      button.classList.toggle('bg-[#0D4F84]', isSelected)
      button.classList.toggle('text-white', isSelected)
      button.classList.toggle('border-[#D5DCE5]', !isSelected)
      button.classList.toggle('bg-white', !isSelected)
      button.classList.toggle('text-[#364153]', !isSelected)
      button.setAttribute('aria-pressed', isSelected.toString())
    })

    this.itemTargets.forEach((item) => {
      const isVisible =
        selectedCategory === 'All Categories' ||
        item.dataset.category === selectedCategory

      item.classList.toggle('hidden', !isVisible)
      if (!isVisible) item.removeAttribute('open')
    })
  }
}
